import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SelectedWorks } from "@/components/SelectedWorks";
import { PartnersMap } from "@/components/PartnersMap";
import { Pricing } from "@/components/Pricing";
import { Marquee } from "@/components/Marquee";
import { Credits } from "@/components/Credits";
import { Footer } from "@/components/Footer";
import { RequestModal } from "@/components/RequestModal";
import { ContourField } from "@/components/ContourField";

function App() {
  const [requestOpen, setRequestOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const openRequest = () => setRequestOpen(true);

  return (
    <div className="App" data-testid="lumen-app">
      <div className="pointer-events-none fixed inset-0 z-0" aria-hidden="true">
        <ContourField seed={11} opacity={0.05} />
      </div>
      <Header onRequest={openRequest} />
      <main className="relative z-[1]">
        <Hero onRequest={openRequest} />
        <SelectedWorks />
        <PartnersMap />
        <Pricing onRequest={openRequest} />
        <Marquee />
        <Credits />
      </main>
      <Footer />
      <RequestModal open={requestOpen} onClose={() => setRequestOpen(false)} />
    </div>
  );
}

export default App;
